module.exports = __webpack_public_path__ + "static/media/logo-omnilogic-white.62260893.png";